module.exports = function(posts) {
	"use strict";
  posts
  .controller('categoryEditController', categoryEditController)
	categoryEditController.$inject = ["$attrs","$scope","$state","$stateParams","getDataService","refreshtokenService","reqursiveService","putDataService","alertService","$rootScope","serverError","offlineError"]
	
  function categoryEditController($attrs,$scope,$state,$stateParams,getDataService,refreshtokenService,reqursiveService, putDataService, alertService,$rootScope,serverError,offlineError) {
    var vmce = this;
    $scope.parent = $scope.$eval($attrs.parent);
    $rootScope.closeEditCategory = function() {
      $rootScope.ngEscapeAttrsParametars = [];
      $scope.parent.categoryEdit = false;
      vmce.category = null;
      $state.transitionTo('app.categories', {id: null}, {
        location: true,
        inherit: true,
        relative: $state.$current,
        notify: false
      });
    }
    vmce.categoryId = $scope.parent.categoryId;
    var getCategoryFunction = function() { 
      $rootScope.hasLoaded = false;
      getDataService.get({param1:'categories', param2: vmce.categoryId}).$promise.then(function(data){
        $rootScope.hasLoaded = true;
        vmce.category = data;
        if(vmce.category.parent) {
          vmce.selectedCategory= {value: vmce.category.parent};
        } else {
          vmce.selectedCategory= {value: 'none'};
        }
      }, function(error){
        if(!window.navigator.onLine) {
          offlineError()
          $rootScope.hasLoaded = true;
          return
        }
        if(error.status ==401) {
          var promise = refreshtokenService.getAccessToken();
          promise.then(
            function(answer) {
              if(answer==200) {
                getCategoryFunction();
              }
              // do something
            },
            function(error) {
            },
            function(progress) {
             // report progress
          });
        } else if(error.status ==502) {
          serverError()
        }  else {
          $scope.parent.categoryEdit = false;
          $state.transitionTo('app.categories', {id: null}, {
            location: true,
            inherit: true,
            relative: $state.$current,
            notify: false
          });
        }
        $rootScope.hasLoaded = true;
      });
    }
    getCategoryFunction();
    if(!window.navigator.onLine) {
      offlineError('refresh')
      return
    }
  }	
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/postsModule/category-edit/js/categoryEditController.js
// module id = 552
// module chunks = 0